var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafDuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 98,
    viewBox: "0 0 112 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.827 92.1272C68.9334 111.489 38.5246 58.2447 74.8807 25.8886C83.7973 17.9531 90.6406 11.7945 99.1591 0.290318C102.249 -3.88085 116.158 37.9276 103.301 59.3568C85.8046 88.519 61.0972 73.0982 85.7009 46.7362C85.7009 46.7362 83.6858 47.2345 83.0621 47.5282C78.576 49.6391 73.8254 58.8758 73.8254 58.0843C73.8254 51.1424 80.4229 39.6113 88.8676 33.0134C89.3611 32.6283 72.4544 39.505 70.1318 53.8615C62.7415 99.5158 106.814 92.9183 111.827 92.1272Z",
    fill: "url(#paint0_linear_9_9433)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 93.1304C38.0016 110.284 53.0437 73.3381 53.5712 62.5187C54.8914 35.4558 30.3281 25.143 12.6679 1.29398C9.5789 -2.87719 -4.33166 38.9308 8.5258 60.36C26.0224 89.5218 50.7289 74.1019 26.1257 47.7398C26.1257 47.7398 28.1416 48.2378 28.7645 48.5318C33.251 50.6428 38.0011 59.879 38.0011 59.0879C38.0011 52.1457 31.4037 40.615 22.959 34.0175C22.4658 33.6319 39.3722 40.5091 41.6957 54.8651C49.0851 100.52 5.01434 93.9224 0 93.1304Z",
    fill: "url(#paint1_linear_9_9433)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7469 27.6603C43.0393 27.6603 43.025 6.9151 56.7469 6.9151C70.4536 6.91553 70.4679 27.6603 56.7469 27.6603Z",
    fill: "url(#paint2_linear_9_9433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_9433",
    x1: 85.2637,
    y1: 0,
    x2: 85.2637,
    y2: 96.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_9433",
    x1: 26.8111,
    y1: 1.00366,
    x2: 26.8111,
    y2: 97.6044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_9433",
    x1: 56.7465,
    y1: 6.9151,
    x2: 56.7465,
    y2: 27.6603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC4EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafDuo);
export default __webpack_public_path__ + "static/media/leaf-duo.1ac2fe12e27e1d343b11911a7ff6e507.svg";
export { ForwardRef as ReactComponent };